import api from './api';

const clinicService = {
  /** Role-scoped picker source: admin=all active, rep=their clinics, clinic=their own. */
  getClinics: () => api.get('/clinics'),
  /** The admin table. `removed: true` lists exactly the rows an admin took out of the list. */
  adminList: (opts = {}) =>
    api.get('/admin/clinics', opts.removed ? { params: { removed: 'true' } } : undefined),
  /**
   * Take a clinic out of the Clinics tab and every picker. QUICKBOOKS IS UNTOUCHED - this is our
   * own record only, and the next sync still refreshes the row's name and phone. Restorable.
   */
  remove: (clinicId) => api.delete(`/admin/clinics/${clinicId}`),
  /** Put a removed clinic back. Find them with adminList({ removed: true }). */
  restore: (clinicId) => api.post(`/admin/clinics/${clinicId}/restore`),
  /** Pull QB Customers into the clinic list (upsert by QB customer id). */
  syncFromQuickBooks: () => api.post('/admin/clinics/sync'),
  /** Replace the FULL set of clinics a sales_rep covers. */
  assignRepClinics: (userId, clinicIds) => api.put(`/admin/users/${userId}/clinics`, { clinicIds }),
  /** The size -> units catalog for the order line-item size picker (TC-260727-23). */
  getSizes: () => api.get('/sizes'),
  /** Admin sets a clinic's per-unit rate ($/unit). null clears it (-> invoices needs_attention). */
  setRate: (clinicId, ratePerUnit) => api.put(`/admin/clinics/${clinicId}/rate`, { ratePerUnit }),
  /** Admin rules whether a QB customer is a real practice; false hides it from every picker. */
  setPractice: (clinicId, isPractice) =>
    api.put(`/admin/clinics/${clinicId}/practice`, { isPractice }),
  /** Stop or resume weekly statements for one customer - collections, litigation (8/31/26). */
  setStatementsPaused: (clinicId, statementsPaused) =>
    api.put(`/admin/clinics/${clinicId}/statements-paused`, { statementsPaused }),
  /** Additional CC recipients for MedEffects statements. QuickBooks Customer API exposes only the primary email. */
  setStatementCc: (clinicId, statementCcEmails) =>
    api.put(`/admin/clinics/${encodeURIComponent(clinicId)}/statement-cc`, { statementCcEmails }),
  /** Admin sets the USD credit limit shown in My Hub (9/4/26). Explicit null clears it. */
  setCreditLimit: (clinicId, creditLimit) =>
    api.put(`/admin/clinics/${clinicId}/credit-limit`, { creditLimit }),
};

export default clinicService;
